import '../Styles/utilsStyle.css';

function Offices() {
    return (
        <div className="mainContainer">
            <h1>Offices</h1>
            <p>
                BCA is so much more than just an auction house, our network expands nationwide as well as in the UK.
                These professionals are very skilled in providing not only answers to your questions regarding the
                possibility of using BCA but also in other business strategies that will optimize your current
                operations without having the need of a complete overhaul. These techniques are innovative and all
                backed by a large corporation. Contact the office nearest to you for more information.
            </p>

            <p><strong>Main office:</strong> 414 S Main Street #201 • Rochester, MI 48307</p>
            <p><strong>Email:</strong> contact@bigcircleauctions.com</p>
            <p><strong>Phone Number:</strong> 855-2WINBCA (855-294-6222)</p>
            <p>
                <strong>Contact info:</strong>{' '}
                <a href="https://www.capitolbuildingpartners.com/get-connected/" target="_blank" rel="noreferrer">
                    www.capitolbuildingpartners.com/get-connected/
                </a>
            </p>

            <h2>The Community Corp Offices</h2>

            {/* Repeated cards kept same structure */}

            <div className="contact-card">
                <h3>Arda Ventures</h3>
                <p><strong>Address:</strong> Manassas, VA 20109</p>
                <p><strong>Email:</strong> meeta@cascadesps.com</p>
                <p><strong>Phone:</strong> 703-791-9852</p>
                <p><strong>Contact Person:</strong> Meeta Patel</p>
            </div>

            <div className="contact-card">
                <h3>Chazaq Ventures</h3>
                <p><strong>Address:</strong> Elkhart, IN 46514</p>
                <p><strong>Email:</strong> mike@radonenvironmental.com</p>
                <p><strong>Phone:</strong> 574-904-6133</p>
                <p><strong>Contact Person:</strong> Mike Brenneman</p>
            </div>

            <div className="contact-card">
                <h3>Infinite Impact Partners</h3>
                <p><strong>Address:</strong> Aurora, CO 80013</p>
                <p><strong>Email:</strong> mbrennan.iip@gmail.com</p>
                <p><strong>Phone:</strong> 720-989-6166</p>
                <p><strong>Contact Person:</strong> John and Michelle Brennan</p>
            </div>

            <div className="contact-card">
                <h3>Genova Partners</h3>
                <p><strong>Address:</strong> Rochester, MI 48307</p>
                <p><strong>Email:</strong> pinnaclecaprate@gmail.com</p>
                <p><strong>Phone:</strong> 248-224-7892</p>
                <p><strong>Contact Person:</strong> Neil Yaldo</p>
            </div>

            <div className="contact-card">
                <h3>Open Door 24</h3>
                <p><strong>Address:</strong> Wellington, CO 80549</p>
                <p><strong>Email:</strong> dynamicimagellc@yahoo.com</p>
                <p><strong>Phone:</strong> 970-581-8112</p>
                <p><strong>Contact Person:</strong> Joshua Griffin</p>
            </div>

            <div className="contact-card">
                <h3>Open Door 24 (Satellite Office)</h3>
                <p><strong>Address:</strong> Holdrege, NE 68949</p>
                <p><strong>Email:</strong> jw@gciworld.org</p>
                <p><strong>Phone:</strong> 303-489-5752</p>
                <p><strong>Contact Person:</strong> Jim Weber</p>
            </div>

            <div className="contact-card">
                <h3>Pilsung Ventures</h3>
                <p><strong>Address:</strong> Minnetrista, MN 55331</p>
                <p><strong>Email:</strong> contact@pilsungventures.com</p>
                <p><strong>Phone:</strong> 855-2WINBCA</p>
                <p><strong>Contact Person:</strong> David Befort</p>
            </div>

            <div className="contact-card">
                <h3>Legacy 360</h3>
                <p><strong>Address:</strong> Fort Myers, FL 33967</p>
                <p><strong>Email:</strong> Wealthcodeconsultants@gmail.com</p>
                <p><strong>Phone:</strong> 239-595-1838</p>
                <p><strong>Contact Persons:</strong> Dale Perrigo, Susan Pilkenton</p>
            </div>

            <div className="contact-card">
                <h3>Tayo Consulting</h3>
                <p><strong>Address:</strong> Orinda, CA 94563</p>
                <p><strong>Email:</strong> john@capitolbuildingpartners.com</p>
                <p><strong>Phone:</strong> (415) 505-8092</p>
                <p><strong>Contact Person:</strong> John Perrings</p>
            </div>

            <div className="contact-card">
                <h3>Fountainhead Ventures</h3>
                <p><strong>Address:</strong> Jacksboro, TN 37757</p>
                <p><strong>Email:</strong> gary@fountainheadventures.llc</p>
                <p><strong>Phone:</strong> (859) 221-2578</p>
                <p><strong>Contact Person:</strong> Gary Geveshausen (Manager)</p>
            </div>

            <div className="contact-card">
                <h3>Midpacific Futures</h3>
                <p><strong>Address:</strong> Aiea, HI 96701</p>
                <p><strong>Email:</strong> fraserhaug@gmail.com</p>
                <p><strong>Phone:</strong> (808) 864-6014</p>
                <p><strong>Contact Person:</strong> Fraser Haug</p>
            </div>

            <div className="contact-card">
                <h3>30 West Consulting</h3>
                <p><strong>Address:</strong> Fort Worth, TX 76131</p>
                <p><strong>Email:</strong> travis@30wconsulting.com</p>
                <p><strong>Phone:</strong> 817-726-5694</p>
                <p><strong>Contact Person:</strong> Travis Fairbairn</p>
            </div>

            <div className="contact-card">
                <h3>Siguro Ventures</h3>
                <p><strong>Address:</strong> Wamego, KS 66547</p>
                <p><strong>Email:</strong> rjcosta4@gmail.com</p>
                <p><strong>Phone:</strong> 719 290-5067</p>
                <p><strong>Contact Person:</strong> Rick Costa</p>
            </div>

            <div className="contact-card">
                <h3>Camelot Community Ventures</h3>
                <p><strong>Address:</strong> Cardiff, CF45 3LN (Wales)</p>
                <p><strong>Email:</strong> richard@camelotcommunityventures.com</p>
                <p><strong>Phone:</strong> +44 7946 153470</p>
                <p><strong>Contact Person:</strong> Richard Eynon</p>
            </div>
        </div>
    );
}

export default Offices;
